import React, { memo } from 'react';

import Button from '@/components/button/Button';

import type { FoldoutItemProps } from '@/components/autocomplete/types';

const FoldoutItem = ({
	optionFlagKey,
	optionIconKey,
	optionDescriptionKey,
	optionTitleKey,
	optionSubTitleKey,
	item,
	handleItem,
}: FoldoutItemProps) => {
	const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.preventDefault();
		handleItem && handleItem(item);
	};

	return (
		<div onClick={handleOnClick} className="section-item">
			<Button
				className="btn-subtitle"
				iconClassName={optionFlagKey && item[optionFlagKey] ? 'flag' : undefined}
				iconName={
					(optionIconKey && item[optionIconKey]) ||
					(optionFlagKey && item[optionFlagKey] && `flag-${item[optionFlagKey]}`) ||
					undefined
				}
				description={optionDescriptionKey ? item[optionDescriptionKey] : undefined}
				title={optionTitleKey ? item[optionTitleKey] : undefined}
				subTitle={optionSubTitleKey ? item[optionSubTitleKey] : undefined}
				type="link-border"
			/>
		</div>
	);
};

export default memo(FoldoutItem);
